export var labelFormatter = function labelFormatter(formatter, chartCalculations, dataId) {
  var dataPoint = chartCalculations.data.find(function (d) {
    return d.id === dataId;
  });
  var name = dataPoint.name;
  return formatter(name);
};